export const SET_DATA = 'SET_DATA'
export const DELETE_DATA_BOOKMARKS = 'DELETE_DATA_BOOKMARKS'
export const CREATE_BOOKMARK_ITEM = 'CREATE_BOOKMARK_ITEM'
export const SET_LOAD_MORE = 'SET_LOAD_MORE'
